import { createFileRoute } from '@tanstack/react-router'

import { ProcessDocumentErrorPage } from '@/pages/_app/process-document/error/page'

export interface ValidatedSearchParams {
  code?: string
  description?: string
}

export const Route = createFileRoute('/process-document/error')({
  component: ProcessDocumentErrorPage,
  validateSearch: (params): ValidatedSearchParams => {
    return {
      code: typeof params?.code === 'string' ? params.code : undefined,
      description: typeof params?.description === 'string' ? params.description : undefined,
    }
  },
})
